import React from 'react'
import { useState, useEffect } from 'react';

// mui material
import {
    Box, Button,
} from '@mui/material';
import Grid from '@mui/system/Unstable_Grid/Grid';
import AddIcon from '@mui/icons-material/Add';

// project import
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import CancelationList from './CancellationList';
import useApi from 'hooks/useApi';
import AppSettings from 'services/MasterService';
import { CreateCancellation } from './CreateCancellation';

export const Cancellation = () => {

    const [open, setOpen] = useState(false);
    const [selectedRule, setSelectedRule] = useState('');
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);

    const handleCrCloseDialog = () => {
        setOpen(false);
        setSelectedRule(null);
    };

    const handleCrOpenDialog = (selectedRuleUuid) => {
        if (selectedRuleUuid) {
            getCrByUuid.execute(selectedRuleUuid);
        } else {
            setOpen(true);
        }
    };

    const getcrHandler = (response) => {
        setSelectedRule(response.data);
        setOpen(true);
    };

    const getCrListHandler = (response) => {
        const data = response.data;
        setRows(data);
    };

    const cancellationRuleListApi = useApi(AppSettings.getCancellationRuleList, getCrListHandler);
    const getCrByUuid = useApi(AppSettings.getCancelationRuleByUuid, getcrHandler);

    useEffect(() => {
        cancellationRuleListApi.execute();
    }, [reload]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard title={
                <Grid container sx={{ alignItems: 'center', justifyContent: "space-between" }} spacing={gridSpacing}>
                    <Grid item xs={12} md={3}>
                    </Grid>
                    <Grid xs={12} md={3}>
                        <Grid container justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems='center' spacing={gridSpacing}>
                            <Grid item>
                                <Button startIcon={<AddIcon />} variant='contained' color='secondary' onClick={() => handleCrOpenDialog()}>Create Rule</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
                content={false}
            >
                <CancelationList
                    rows={rows}
                    setReload={setReload}
                    open={open}
                    handleOpen={handleCrOpenDialog}

                />
            </MainCard>
            <CreateCancellation
                open={open}
                handleClose={handleCrCloseDialog}
                selectedRule={selectedRule}
                setReload={setReload}
            />
        </Box>
    )
};
